import useIsCompatibilityPathway from 'hooks/use-is-compatibility-pathway';
import useIsPtacPathway from 'hooks/use-is-ptac-pathway';

export default function useHidesCustomerPriorities(): boolean {
  const isCompatibilityPathway = useIsCompatibilityPathway();
  const isPtacPathway = useIsPtacPathway();
  return isCompatibilityPathway || isPtacPathway;
}
